// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/garantias/services/garantiaService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import {
  paramsDaLista, type ListaFiltros, type PaginadoComResumo, type GarantiaListaResumo,
} from '@/features/operacional/services/listaFiltros';
import type {
  GarantiaResumo,
  GarantiaDetalhe,
  GarantiaOcorrencia,
  CriarGarantiaRequest,
  RegistrarOcorrenciaRequest,
  ResolverOcorrenciaRequest,
} from '../types';

const BASE = '/api/garantias';

export const garantiaService = {
  async getAll(
    pagina = 1,
    tamanhoPagina = 20,
    status = 'todos',
    clienteId = 0,
    filtros: Omit<ListaFiltros, 'status'> = {},
  ): Promise<PaginadoComResumo<GarantiaResumo, GarantiaListaResumo>> {
    const { data } = await apiClient.get<PaginadoComResumo<GarantiaResumo, GarantiaListaResumo>>(BASE, {
      params: {
        ...paramsDaLista(pagina, tamanhoPagina, { ...filtros, status }),
        clienteId: clienteId > 0 ? clienteId : undefined,
      },
    });
    return data;
  },

  async getById(id: number): Promise<GarantiaDetalhe> {
    const { data } = await apiClient.get<GarantiaDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(req: CriarGarantiaRequest): Promise<GarantiaResumo> {
    const { data } = await apiClient.post<GarantiaResumo>(BASE, req);
    return data;
  },

  async encerrar(id: number): Promise<void> {
    await apiClient.put(`${BASE}/${id}/encerrar`);
  },

  async registrarOcorrencia(id: number, req: RegistrarOcorrenciaRequest): Promise<GarantiaOcorrencia> {
    const { data } = await apiClient.post<GarantiaOcorrencia>(`${BASE}/${id}/ocorrencias`, req);
    return data;
  },

  async resolverOcorrencia(id: number, oid: number, req: ResolverOcorrenciaRequest): Promise<GarantiaOcorrencia> {
    const { data } = await apiClient.put<GarantiaOcorrencia>(`${BASE}/${id}/ocorrencias/${oid}/resolver`, req);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
